import type { Mission } from '../missions.ts'

export const nasa: Mission = {
  id: "nasa",
  name: "National Aeronautics and Space Administration",
  short: "NASA",
  call: "Exploration",
  kind: "independent",
  url: "https://www.nasa.gov/",
  established: 1958,
  palette: {
    primary: "#0b3d91",
    secondary: "#fc3d21",
    accent: "#1c67e3",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.nasa.gov/nasa-brand-center/brand-guidelines/",
  },
  motif: "orbit",
  mission: {
    text: "NASA explores the unknown in air and space, innovates for the benefit of humanity, and inspires the world through discovery.",
    url: "https://www.nasa.gov/about/",
  },
  fact: {
    text: "NASA opened for business on October 1, 1958, and today works across 20 centers and facilities.",
    url: "https://www.nasa.gov/about/",
  },
  seal: {
    file: "public/seals/nasa.svg",
    source: "https://commons.wikimedia.org/wiki/File:NASA_seal.svg",
  },
  logo: {
    file: "public/logos/nasa.svg",
    source: "https://commons.wikimedia.org/wiki/File:NASA_logo.svg",
  },
  identifier: {
    about: "https://www.nasa.gov/about/",
    accessibility: "https://www.nasa.gov/general/accessibility/",
    foia: "https://www.nasa.gov/foia/",
    noFear: "https://www.nasa.gov/no-fear-act/",
    oig: "https://oig.nasa.gov/",
    performance: "https://www.nasa.gov/budgets-plans-and-reports/",
    privacy: "https://www.nasa.gov/privacy/",
  },
  media: {
    photos: [
      {
        file: "/media/nasa-artemis-rollout.jpg",
        small: "/media/nasa-artemis-rollout-sm.jpg",
        alt: "The Space Launch System rocket on its mobile launcher leaves the Vehicle Assembly Building at night, lit against a dark sky.",
        title: "Artemis I rollout from the Vehicle Assembly Building, Kennedy Space Center, November 2022",
        creator: "Isaac Watson, NASA",
        source: "https://images.nasa.gov/details/KSC-20221104-PH-ILW01_0003",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nasa-crescent-moon.jpg",
        small: "/media/nasa-crescent-moon-sm.jpg",
        alt: "A thin crescent moon above the blue band of Earth's atmosphere at orbital sunrise, with a station solar array at left.",
        title: "Crescent moon above Earth's limb from the International Space Station, May 8, 2019",
        creator: "NASA, Expedition 59 crew",
        source: "https://images.nasa.gov/details/iss059e059210",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/nasa-loop.webm",
      mp4: "/media/nasa-loop.mp4",
      poster: "/media/nasa-loop-poster.jpg",
      title: "Orion captures Earthset behind the Moon, Artemis I flight day 6, November 21, 2022",
      creator: "NASA",
      source: "https://images.nasa.gov/details/ART-SAW2_2022_325_1230B_SHARED_art001m1203251230B",
      license: "Public domain (U.S. government work)",
    },
  },
}
